module.exports = __webpack_public_path__ + "static/media/recommendation.691c12a3.png";